<nz-layout>
  <nz-content class="centered">
    <div class="centered-box-vertical">
      <img class="logo" src="assets/img/teamsystem.png" />
      <h1 i18n="Auth.PasswordReset.Title|title for reset password page@@Auth.PasswordReset.Title">
        Cambia la tua password
      </h1>
      <span style="text-align: center;"
      i18n="Auth.PasswordReset.Subtitle|subtitle for reset password page@@Auth.PasswordReset.Subtitle">
      La password deve avere una lunghezza tra 8 e 16 caratteri, contenere almeno un carattere minuscolo, uno
        maiuscolo, un numero e un carattere speciale.</span>

    <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
        nzTip="Invio richiesta..." [nzSpinning]="isSpinning">  
      <form nz-form [formGroup]="passwordResetForm" class="custom-form" (ngSubmit)="submitForm()">
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control 
              [nzErrorTip]="getValidationErrorMessage(passwordResetForm.controls.temporaryPassword.errors)">
                <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="temporaryPasswordTemplate">
                  <input [type]="temporaryPasswordVisible ? 'text' : 'password'" nz-input
                    formControlName="temporaryPassword" 
                    i18n-placeholder="Auth.PasswordReset.PlaceholderTemporaryPassword|placeholder for temporary password in form@@Auth.PasswordReset.PlaceholderTemporaryPassword"
                    placeholder="Password temporanea" />
                </nz-input-group>
                <ng-template #temporaryPasswordTemplate>
                  <i nz-icon [nzType]="temporaryPasswordVisible ? 'eye-invisible' : 'eye'"
                    (click)="temporaryPasswordVisible = !temporaryPasswordVisible"></i>
                </ng-template>
              </nz-form-control>
            </div>

          </div>
        </nz-form-item>
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control [nzErrorTip]="getValidationErrorMessage(passwordResetForm.controls.newPassword.errors)">
                <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="newPasswordTemplate">
                  <input [type]="newPasswordVisible ? 'text' : 'password'" nz-input formControlName="newPassword"
                  i18n-placeholder="Auth.PasswordReset.PlaceholderNewPassword|placeholder for new password in form@@Auth.PasswordReset.PlaceholderNewPassword"
                  placeholder="Nuova Password" />
                </nz-input-group>
                <ng-template #newPasswordTemplate>
                  <i nz-icon [nzType]="newPasswordVisible ? 'eye-invisible' : 'eye'"
                    (click)="newPasswordVisible = !newPasswordVisible"></i>
                </ng-template>
              </nz-form-control>
            </div>
          </div>
        </nz-form-item>
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control 
              [nzErrorTip]="getValidationErrorMessage(passwordResetForm.controls.confirmNewPassword.errors)">
                <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="confirmNewPasswordTemplate">
                  <input [type]="confirmNewPasswordVisible ? 'text' : 'password'" nz-input
                    formControlName="confirmNewPassword" 
                    i18n-placeholder="Auth.PasswordReset.PlaceholderConfirmNewPassword|placeholder for confirm new password in form@@Auth.PasswordReset.PlaceholderConfirmNewPassword"
                    placeholder="Conferma Nuova Password" />
                </nz-input-group>
                <div *ngIf="passwordResetForm.errors?.passwordsDontMatch && (passwordResetForm.touched || passwordResetForm.dirty)" class="cross-validation-error-message alert alert-danger"
                      i18n="Generic.ValidationError.PasswordsDontMatch|Errore che si ha quando viene chiesto di digitare due volte la password e queste sono diverse@@Generic.ValidationError.PasswordsDontMatch">
                      Le password devono coincidere
                </div>
                <ng-template #confirmNewPasswordTemplate>
                  <i nz-icon [nzType]="confirmNewPasswordVisible ? 'eye-invisible' : 'eye'"
                    (click)="confirmNewPasswordVisible = !confirmNewPasswordVisible"></i>
                </ng-template>
              </nz-form-control>
            </div>
          </div>
        </nz-form-item>

        <div nz-row nzAlign="middle" nzJustify="center">
          <div nz-col [nzSpan]="10">
            <button i18n="Generic.Confirm|label for confirm button@@Generic.Confirm"
            class="submit" nz-button style="width: 100%;" nzType="primary" [disabled]="!passwordResetForm.valid">CONFERMA</button>
          </div>
        </div>
      </form>
    </nz-spin>

    </div>
  </nz-content>
</nz-layout>